import React from 'react';

interface ISingleResultRow {
  hit: any;
  setShowFullRecord: any;
  showFilters: boolean;
}

const ProductRow: React.FC<ISingleResultRow> = ({ showFilters, hit, setShowFullRecord }) => {
  const handleShowFullRecord = (fullHit: any) => {
    setShowFullRecord({ show: true, record: fullHit });
  };

  return (
    <tr className='screening-results-row' onClick={() => handleShowFullRecord(hit)}>
      <div className='screening-results-row-checkbox-cell'>
        {/* add checkbox later */}
      </div>
      <div className='screening-results-row-default-cell'>
        <div
          className='screening-results-row-default-cell-inner'
        >
          <div className='screening-results-row-link-cell-text'>
            {hit?._source['Product Name']}
          </div>
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text'>
            {hit?._source['HS Code']}
          </div>
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text'>
            {hit?._source['List Name']}
          </div>
        </div>
      </div>
      {!showFilters && (
        <>
          <div className='screening-results-row-default-cell'>
            <div className='screening-results-row-default-cell-inner'>
              <div className='screening-results-row-default-cell-text'>
                {hit?._source.Agency}
              </div>
            </div>
          </div>
          <div className='screening-results-row-default-cell'>
            <div className='screening-results-row-default-cell-inner'>
              <div className='screening-results-row-default-cell-text'>
                {hit?._source['Source Country']}
              </div>
            </div>
          </div>
          <div className='screening-results-row-default-cell'>
            <div className='screening-results-row-default-cell-inner'>
              <div className='screening-results-row-default-cell-text'>
                {hit?._source['Date Updated on BITE Platform']}
              </div>
            </div>
          </div>
        </>
      )}
    </tr>
  );
};

export default ProductRow;
